import { render } from "./SpinnerLogo.vue?vue&type=template&id=1f2fc4fb&scoped=true&lang=pug"
import script from "./SpinnerLogo.vue?vue&type=script&lang=js"
export * from "./SpinnerLogo.vue?vue&type=script&lang=js"

import "./SpinnerLogo.vue?vue&type=style&index=0&id=1f2fc4fb&scoped=true&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2fc4fb"]])

export default __exports__